/* ==========================================================================
   Header > Client > Welcome
   ========================================================================== */

const $ = require('jquery');
const { getCookie } = require('./cookie');

function initWelcome() {
    const modalNewUserCookie = getCookie('login_modal_new_user');

    if (modalNewUserCookie === '') {
        const $containerModalLogin = $('#loginModal');
        const literals = $('#loginModal').data('literals');
        const links = {
            login: {
                href: $containerModalLogin.find('.log-in__link').attr('href'),
                title: $containerModalLogin.find('.log-in__link').attr('title')
            },
            create: {
                href: $containerModalLogin.find('.footer-modal__link').attr('href'),
                title: $containerModalLogin.find('.footer-modal__link').attr('title')
            }
        };

        document.cookie = 'login_modal_new_user=1; expire=; path=/;';
        replaceData({ $containerModalLogin, literals, links });
    }
}
function replaceData({ $containerModalLogin, literals, links }) {
    if ($containerModalLogin) return;
    $containerModalLogin.find('.content__title').html(literals.loginModalNewUserTitle);
    $containerModalLogin.find('.content__description').html(literals.loginModalNewUserDescription);
    $containerModalLogin.find('.log-in .Button').html(literals.loginModalNewUserButtonText);
    $containerModalLogin.find('.footer-modal__text').html(`${literals.loginModalNewUserFooterText} &nbsp;`);
    $containerModalLogin.find('.footer-modal__link').html(literals.loginModalButtonText);
    $containerModalLogin.find('.icon__content').html('');
    $containerModalLogin
        .find('.log-in__link')
        .attr('href', links.create.href)
        .attr('title', links.create.title);
    $containerModalLogin.find('.log-in__link').html(links.create.title);
    $containerModalLogin
        .find('.footer-modal__link')
        .attr('href', links.login.href)
        .attr('title', links.login.title);
    $containerModalLogin.find('.footer-modal__link').html(links.login.title);
}

module.exports = {
    initWelcome
};
